// extracted by mini-css-extract-plugin
export var hideOnFixed = "range-module--hideOnFixed--61292";
export var inputTariff = "range-module--inputTariff--9908d";
export var range = "range-module--range--99eda";
export var rangeDesc = "range-module--rangeDesc--74b2a";
export var summary = "range-module--summary--591c1";
export var summaryValue = "range-module--summaryValue--f09f3";